import { render, staticRenderFns } from "./AboutInstruments.vue?vue&type=template&id=fa3251d8&"
import script from "./AboutInstruments.vue?vue&type=script&lang=js&"
export * from "./AboutInstruments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports